import React from "react";

export function AppStoreBadge({
  store,
  href,
  large = false,
}: {
  store: "ios" | "android";
  href: string;
  large?: boolean;
}) {
  const targetHeight = large ? 56 : 40;
  // Google Play badge PNG has built-in transparent padding; scale it up so the
  // visible badge content fills the same height as the App Store badge, then
  // clip the overflow symmetrically via the wrapper.
  const imgHeight =
    store === "android" ? Math.round(targetHeight * 1.45) : targetHeight;

  const label =
    store === "ios" ? "Download on the App Store" : "Get it on Google Play";
  const src =
    store === "ios"
      ? `${process.env.PUBLIC_URL}/app-store-badge.svg`
      : `${process.env.PUBLIC_URL}/google-play-badge.png`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="inline-flex items-center transition hover:opacity-80"
      style={{ height: targetHeight, overflow: "hidden" }}
    >
      <img
        src={src}
        alt={label}
        style={{ height: imgHeight, width: "auto", display: "block" }}
      />
    </a>
  );
}
